<template>
  <BaseAuthenticationLayout>
    <BaseBackButton to="/sign_in" class="mb-2"> Retour </BaseBackButton>
    <BaseHeader class="mb-6">
      <span>Inscription</span>
    </BaseHeader>
    <BaseHeaderDescription class="mb-6">
      <span
        >ATTENTION! Si vous êtes étudiant et que vous créez votre compte en tant qu'externe, votre
        inscription au cours ne sera pas prise en compte.</span
      >
    </BaseHeaderDescription>
    <form @submit.prevent="submit">
      <div class="mb-20">
        <BaseSelect
          v-model="kind"
          title="Type de compte"
          label="Type de compte"
          required
          :items="kinds"
          v-if="external"
          @change="kindHandler"
        />
        <BaseInput v-model="email" label="Email" required type="email" class="mb-6" />
        <BaseInput v-model="password" label="Mot de passe" required type="password" class="mb-6" />
        <BaseInput v-model="firstname" label="Prénom" required class="mb-6" />
        <BaseInput v-model="lastname" label="Nom" required class="mb-6" />
        <BaseRadioGroup
          v-model="female"
          :radio-list="radioList"
          label="Genre"
          color="brand-secondary tone-400"
          mandatory
        />
        <BaseInput v-model="phone_number" label="Numéro de téléphone" required class="my-6" />
        <BaseInput
          v-model="student_number"
          label="Numéro étudiant"
          required
          class="mb-6"
          v-if="!external"
        />
        <BaseFilter
          v-if="!external"
          :label="$t('Program')"
          placeholder="Choisissez une formation"
          class="mb-4 d-md-none"
          :items="programs.data"
          modal-title="Formation"
          submit-button-text="Valider"
          :multiple="false"
          @change="programHandler"
          :text-value="programSelectText"
        />
        <BaseSelect
          v-if="!external"
          v-model="program_id"
          :title="$t('Program')"
          :label="$t('Choose your program')"
          :items="programs.data"
          class="d-none d-md-block"
        />
        <BaseCheckbox
          v-model="consent"
          class="mb-12"
          label="J'autorise, à titre gratuit, l'Université Paris XIII dénommée Sorbonne Paris Nord à publier les photographies/diffuser les images prises de ma personne pendant mes cours, aucune exploitation commerciale ne sera faite des données conservées"
        />
        <div :class="{ 'sticky-bottom neutral tone-100 pb-6': $vuetify.breakpoint.smAndDown }">
          <BaseButton
            class="white--text my-2"
            color="brand-primary tone-400"
            :height="56"
            type="submit"
            block
          >
            Me connecter
          </BaseButton>
        </div>
      </div>
    </form>
  </BaseAuthenticationLayout>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapMutations } from 'vuex';
import BaseHeader from '@/components/BaseHeader.vue';
import BaseHeaderDescription from '@/components/BaseHeaderDescription.vue';
import BaseInput from '@/components/BaseInput.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioGroup from '@/components/BaseRadioGroup.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseFilter from '@/components/BaseFilter.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseAuthenticationLayout from '@/components/BaseAuthenticationLayout.vue';
import BaseBackButton from '@/components/BaseBackButton.vue';
import passwordMixin from './mixins/passwordMixin';
import { SET_ALERT } from '../store/mutation-types';

export default {
  name: 'SignUp',
  mixins: [passwordMixin],
  components: {
    BaseHeader,
    BaseHeaderDescription,
    BaseInput,
    BaseButton,
    BaseRadioGroup,
    BaseCheckbox,
    BaseFilter,
    BaseSelect,
    BaseAuthenticationLayout,
    BaseBackButton,
  },
  computed: {
    emailMatch() {
      return (
        this.emailConfirmation === this.email || "L'email et sa confirmation ne correspondent pas"
      );
    },
    ...mapFields([
      'signUp.email',
      'signUp.password',
      'signUp.firstname',
      'signUp.lastname',
      'signUp.phone_number',
      'signUp.student_number',
      'signUp.female',
      'signUp.program_id',
      'programs',
      'signUp.consent',
      'signUp.kind',
    ]),
    checkboxLabel() {
      return "J'autorise, à titre gratuit, l'Université Paris XIII dénommée Sorbonne Paris Nord à publier les photographies/diffuser les images prises de ma personne pendant mes cours, aucune exploitation commerciale ne sera faite des données conservées";
    },
    incomplete() {
      return this.$route.query.incomplete === 'true';
    },
    programSelectText() {
      if (this.program_id) {
        const selectedProgram = this.programs.data.find(
          (program) => program.id === this.program_id,
        );

        return selectedProgram.attributes.name;
      }
      return 'Sélectionnez un programme';
    },
  },
  methods: {
    ...mapActions([
      'signUp',
      'fetchPrograms',
      'fetchMe',
      'signUpAfterCasAuthentication',
      'fetchMeAndFillSignUpForm',
    ]),
    ...mapMutations([SET_ALERT]),
    submit() {
      if (this.$route.query.incomplete === 'true') {
        this.signUpAfterCasAuthentication();
      } else {
        this.signUp().catch((error) => {
          if (error.response.data.errors.email) {
            this[SET_ALERT]({
              show: true,
              text: this.$t('An account with this email already exists'),
              color: 'error',
              timeout: 10000,
            });
          }
        });
      }
    },
    programHandler(programId) {
      this.program_id = programId;
    },
    kindHandler(value) {
      this.kind = value;
    },
  },
  data() {
    return {
      external: false,
      radioList: [
        {
          label: 'Homme',
          value: false,
        },
        {
          label: 'Femme',
          value: true,
        },
      ],
      passwordVisibility: false,
      emailConfirmation: '',
      kinds: [
        {
          attributes: {
            name: 'Externe',
          },
          id: 'external',
        },
        {
          attributes: {
            name: 'Personnel',
          },
          id: 'staff',
        },
      ],
    };
  },
  created() {
    this.fetchPrograms();
    if (this.incomplete) {
      this.fetchMeAndFillSignUpForm();
    }
    this.external = this.$route.query.external === 'true';
  },
};
</script>
